import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Grid, 
  Paper,
  styled 
} from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8]
  }
}));

const ImageWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '200px',
  marginBottom: theme.spacing(2),
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease-in-out',
  },
  '&:hover img': {
    transform: 'scale(1.05)'
  }
}));

const ComparisonTile = ({ image, title, description }) => {
  return (
    <StyledPaper elevation={3}>
      <ImageWrapper>
        <img 
          src={image} 
          alt={title}
        />
      </ImageWrapper>
      <Typography 
        variant="h6" 
        component="h3" 
        sx={{ 
          color: '#0d9488',
          fontWeight: 600,
          mb: 1
        }}
      >
        {title}
      </Typography>
      <Typography 
        color="text.secondary"
        sx={{ flex: 1 }}
      >
        {description}
      </Typography>
    </StyledPaper>
  );
};

const ExamplesSection = () => {
  const comparisons = [
    {
      image: "/SearchChat - example-left.jpg",
      title: "Search",
      description: "Quick search results, suggestions and AI answers."
    },
    {
      image: "/SearchChat - example-right.jpg",
      title: "Chat",
      description: "Advanced semantic search that understands context, user intent, and provides more accurate results."
    }
  ];

  return (
    <Box 
      component="section" 
      sx={{
        py: 8,
        bgcolor: 'background.paper'
      }}
    >
      <Container>
        <Typography 
          variant="h3" 
          component="h2"
          align="center"
          sx={{
            color: '#0d9488',
            fontWeight: 700,
            mb: 6
          }}
        >
          Awsome Search.. and Chat
        </Typography>
        
        <Grid container spacing={4}>
          {comparisons.map((comparison, index) => (
            <Grid item xs={12} md={6} key={index}>
              <ComparisonTile {...comparison} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ExamplesSection;